export enum ScheduleItemDirectionEnum {
    Start = 0,
    End = 1,
}
